import React from "react";
import { motion } from "framer-motion";

const PageLoader = () => {
  return (
    <div className="min-h-screen inset-0 flex items-center justify-center bg-background z-50"></div>
  );
};

export default PageLoader;
